module.exports = __webpack_public_path__ + "img/parttwo_pic3.d1d18c49.png";